import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Config from './config'
import axios from 'axios'
import vuetify from './plugins/vuetify';
import store from './store'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import './plugins/vue-moment'
import YfxCloudAuth from '@yodatech/vue-yfx-cloud-auth'
import YfxLicenseAuth from '@yodatech/vue-yfx-license'
import VueTimers from "vue-timers"


Vue.use(YfxCloudAuth, {serviceName: "web-yfx-connect-registry", store: store, axios: axios, ...Config.authConfig})
Vue.use(YfxLicenseAuth, {axios: axios})
Vue.use(VueTimers);

Vue.config.productionTip = false

Vue.prototype.$http = axios
Vue.prototype.$config = Config

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app')
